@if (assignment) {
  <div class="acting-as-band" role="alert">
    <span class="acting-as-text">
      <span>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
             class="lucide lucide-user-star-icon lucide-user-star"><path
          d="M16.051 12.616a1 1 0 0 1 1.909.024l.737 1.452a1 1 0 0 0 .737.535l1.634.256a1 1 0 0 1 .588 1.806l-1.172 1.168a1 1 0 0 0-.282.866l.259 1.613a1 1 0 0 1-1.541 1.134l-1.465-.75a1 1 0 0 0-.912 0l-1.465.75a1 1 0 0 1-1.539-1.133l.258-1.613a1 1 0 0 0-.282-.866l-1.156-1.153a1 1 0 0 1 .572-1.822l1.633-.256a1 1 0 0 0 .737-.535z"/><path
          d="M8 15H7a4 4 0 0 0-4 4v2"/><circle cx="10" cy="7" r="4"/></svg>
      </span>
      <span>
        กำลังดำเนินการแทน:
        <span>{{ assignment.grantorName || assignment.grantorTaxId || 'ผู้มอบสิทธิ์' }}</span>
        @if (assignment.businessName) {
          <span>&nbsp;({{ assignment.businessName }}{{ assignment.businessCode ? ' · ' + assignment.businessCode : '' }}
            )</span>
        }
      </span>
    </span>
    <button type="button" class="acting-as-back" (click)="switchBack()">
      <i class="bi bi-arrow-left"></i> กลับไปบัญชีของฉัน
    </button>
  </div>
}
